import { render, staticRenderFns } from "./PolicyFunds.vue?vue&type=template&id=0e6ac20c&"
import script from "./PolicyFunds.vue?vue&type=script&lang=ts&"
export * from "./PolicyFunds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports